import React, { Component } from "react";
import config from "lib/fr-config";
import CommonSplitView from "presentational/common/CommonSplitView";
import ImageOnlyModalView from "presentational/common/modals/ImageOnlyModalView";
import TextButtonView from "presentational/common/TextButtonView";
import ItemUnitListView from "presentational/common/itemUnit/ItemUnitListView";
import OutfitImageView from "presentational/common/OutfitImageView";
import MySelectableItemListView from "presentational/upload/MySelectableItemListView";
import IconButtonView from "presentational/common/IconButtonView";
import TXT from "presentational/common/multinational/TXT";
import { existThisUnitInList, getRemovedList } from "lib/itemListUtil";
import { getDeviceType } from "lib/deviceInfo";
import styles from "./ItemAdderPanelView.scss";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

const OUTFIT_IMAGE_WIDTH_PERCENT = 30;
const OUTFIT_VERTICAL_PADDING_PX = 10;
const IMAGE_RATIO = config.outfitImage.RATIO;

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const colorCss = config.css.color;

const cssXL = {
  buttonArea: {
    marginBottom: desktopCss.standardPaddingBetweenContent
  },
  tabBarArea: {
    marginBottom: desktopCss.standardPaddingBetweenContent
  }
};
const cssXS = {
  root: {
    marginTop: -mobileCss.paddingBetweenHeaderbarAndFirstContent
  },
  buttonArea: {
    height: `calc(env(safe-area-inset-bottom) + ${mobileCss.headerBarHeightPX}px)`
  },
  buttonWrapper: {
    paddingBottom: "calc(env(safe-area-inset-bottom))"
  },
  imageFrame: {
    backgroundColor: colorCss.colorOfBackground,
    position: "sticky",
    top: 0,
    zIndex: 1200 /** 아웃핏 클릭후 나타나는 모달보다 약간 작은 값으로 설정함 */,

    /**
     * marginLeft, width: 상단에 떠있는 아웃핏 이미지의
     * 우측에 1px정도 짧게 계산되어 겹쳐있는 아이템 썸네일이 일부 노출된다
     * (안드로이드 모바일 한정)
     * 그래서 의도적으로 sidePadding 만큼의 좌우 마진 추가함.
     * */
    marginLeft: -mobileCss.sidePadding,
    width: `calc(100% + ${mobileCss.sidePadding * 2}px)`
  },
  imageWrapper: {
    width: `${OUTFIT_IMAGE_WIDTH_PERCENT}%`,
    padding: `${OUTFIT_VERTICAL_PADDING_PX}px 0`
  },
  tabBarArea: {
    marginTop: mobileCss.paddingBetweenHeaderbarAndFirstContentForOutfitUpload,
    marginBottom: mobileCss.standardPaddingBetweenContent
  },
  itemUnitListWrapper: {
    marginTop: -mobileCss.minusPaddingBetweenContentsForOutfitUpload
  }
};

class ItemAdderPanelView extends Component {
  static propTypes = {
    stickeredImageDataURL: PropTypes.string.isRequired,
    selectedItemList: PropTypes.array.isRequired,
    onItemUploadBtnClick: PropTypes.func.isRequired,
    onSelectListChange: PropTypes.func.isRequired,
    onBackBtnClick: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(["outfitUpload", "outfitEdit"]).isRequired,
    onNextBtnClick: PropTypes.func.isRequired,
    catListOfMine: PropTypes.array,
    selectedCategory: PropTypes.string,
    selectableItemList: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isEnd: PropTypes.bool.isRequired,
    onDropdownSelect: PropTypes.func.isRequired,
    onNextItemListRequest: PropTypes.func.isRequired
  };

  state = {
    tabValue: "myitem",
    open: false
  };

  getWidthOfLeftSide = fixedHeightValue => {
    const { innerHeight } = window;
    const imageHeight = innerHeight - fixedHeightValue;
    return imageHeight * IMAGE_RATIO;
  };

  hideOrShow(type, element) {
    if (type === "show") {
      return <div>{element}</div>;
    } else if (type === "hide") {
      return <div style={{ display: "none" }}>{element}</div>;
    }
  }

  getCancelBtnType() {
    const { mode } = this.props;
    return mode === "outfitUpload"
      ? "back"
      : mode === "outfitEdit"
      ? "close"
      : null;
  }

  handleModalOpen = () => {
    this.setState({ open: true });
  };

  handleModalClose = () => {
    this.setState({ open: false });
  };

  handleTabBtnClick = tabValue => () => {
    this.setState({ tabValue });
  };

  handleSelectForSelectedList = unit => {
    const { selectedItemList, onSelectListChange } = this.props;

    onSelectListChange(getRemovedList({ unit, selectedItemList }));
  };

  handleSelectForSelectableItemList = unit => {
    const { selectedItemList, onSelectListChange } = this.props;

    if (existThisUnitInList({ unit, selectedItemList })) {
      onSelectListChange(
        getRemovedList({
          unit,
          selectedItemList
        })
      );
    } else {
      onSelectListChange(selectedItemList.concat(unit));
    }
  };

  mobileLayout() {
    const {
      stickeredImageDataURL,
      onItemUploadBtnClick,
      selectedItemList,
      onBackBtnClick,
      onNextBtnClick,
      catListOfMine,
      isLoading,
      isEnd,
      selectedCategory,
      selectableItemList,
      onDropdownSelect,
      onNextItemListRequest
    } = this.props;
    const { tabValue, open } = this.state;
    const css = cssXS;
    const deviceType = getDeviceType();

    return (
      <div className={cx("root", deviceType)} style={css.root}>
        <div className={cx("main-area")}>
          <div style={css.imageFrame}>
            <div
              className={cx("image-wrapper")}
              style={css.imageWrapper}
              onClick={this.handleModalOpen}
            >
              <OutfitImageView imageSrc={stickeredImageDataURL} />
            </div>
          </div>
          <ImageOnlyModalView
            open={open}
            imageRatio={IMAGE_RATIO}
            imageSrc={stickeredImageDataURL}
            onClose={this.handleModalClose}
          />
          <div className={cx("tab-bar-area")} style={css.tabBarArea}>
            <TextButtonView
              design={tabValue === "selecteditem" ? "select" : "unselect"}
              onClick={this.handleTabBtnClick("selecteditem")}
            >
              <TXT name="btnTab_selectedItems" />
            </TextButtonView>
            <TextButtonView
              disableRightMargin
              design={tabValue === "myitem" ? "select" : "unselect"}
              onClick={this.handleTabBtnClick("myitem")}
            >
              <TXT name="btnTab_myItems" />
            </TextButtonView>
          </div>
          <div>
            {this.hideOrShow(
              tabValue === "selecteditem" ? "show" : "hide",
              <div style={css.itemUnitListWrapper}>
                <ItemUnitListView
                  itemList={selectedItemList}
                  onItemClick={this.handleSelectForSelectedList}
                />
              </div>
            )}
            {this.hideOrShow(
              tabValue === "myitem" ? "show" : "hide",
              <div className={cx("my-item-list-area")}>
                <MySelectableItemListView
                  onItemSelect={this.handleSelectForSelectableItemList}
                  markedList={selectedItemList}
                  catListOfMine={catListOfMine}
                  isLoading={isLoading}
                  isEnd={isEnd}
                  selectedCategory={selectedCategory}
                  onDropdownSelect={onDropdownSelect}
                  onNextItemListRequest={onNextItemListRequest}
                  selectableItemList={selectableItemList}
                  onItemUploadBtnClick={onItemUploadBtnClick}
                  parentCssValueForMobile={{
                    widthPercentOfOutfit: OUTFIT_IMAGE_WIDTH_PERCENT,
                    verticalPaddingOfOutfit: OUTFIT_VERTICAL_PADDING_PX
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <div className={cx("button-area")} style={css.buttonArea}>
          <div style={css.buttonWrapper}>
            <IconButtonView
              type={this.getCancelBtnType()}
              onClick={onBackBtnClick}
            />
          </div>
          <div style={css.buttonWrapper}>
            <IconButtonView type={"next"} onClick={onNextBtnClick} />
          </div>
        </div>
      </div>
    );
  }

  desktopLayout() {
    const {
      stickeredImageDataURL,
      onItemUploadBtnClick,
      selectedItemList,
      onBackBtnClick,
      onNextBtnClick,
      catListOfMine,
      isLoading,
      isEnd,
      selectedCategory,
      selectableItemList,
      onDropdownSelect,
      onNextItemListRequest
    } = this.props;
    const { tabValue, open } = this.state;
    const css = cssXL;
    const deviceType = getDeviceType();

    return (
      <div className={cx("root", deviceType)}>
        <CommonSplitView
          getWidthOfLeftSide={this.getWidthOfLeftSide}
          leftSideComponent={
            <div className={cx("float-area")}>
              <div
                className={cx("image-wrapper")}
                onClick={this.handleModalOpen}
              >
                <OutfitImageView imageSrc={stickeredImageDataURL} />
              </div>
              <ImageOnlyModalView
                open={open}
                imageRatio={IMAGE_RATIO}
                imageSrc={stickeredImageDataURL}
                onClose={this.handleModalClose}
              />
            </div>
          }
          rightSideComponent={
            <div>
              <div className={cx("button-area")} style={css.buttonArea}>
                <IconButtonView
                  type={this.getCancelBtnType()}
                  onClick={onBackBtnClick}
                />
                <IconButtonView
                  type={"next"}
                  disableRightMargin
                  onClick={onNextBtnClick}
                />
              </div>
              <div className={cx("tab-bar-area")} style={css.tabBarArea}>
                <TextButtonView
                  design={tabValue === "selecteditem" ? "select" : "unselect"}
                  onClick={this.handleTabBtnClick("selecteditem")}
                >
                  <TXT name="btnTab_selectedItems" />
                </TextButtonView>
                <TextButtonView
                  disableRightMargin
                  design={tabValue === "myitem" ? "select" : "unselect"}
                  onClick={this.handleTabBtnClick("myitem")}
                >
                  <TXT name="btnTab_myItems" />
                </TextButtonView>
              </div>
              <div>
                {this.hideOrShow(
                  tabValue === "selecteditem" ? "show" : "hide",
                  <ItemUnitListView
                    itemList={selectedItemList}
                    onItemClick={this.handleSelectForSelectedList}
                  />
                )}
                {this.hideOrShow(
                  tabValue === "myitem" ? "show" : "hide",
                  <div className={cx("my-item-list-area")}>
                    <MySelectableItemListView
                      onItemSelect={this.handleSelectForSelectableItemList}
                      markedList={selectedItemList}
                      catListOfMine={catListOfMine}
                      isLoading={isLoading}
                      isEnd={isEnd}
                      selectedCategory={selectedCategory}
                      onDropdownSelect={onDropdownSelect}
                      onNextItemListRequest={onNextItemListRequest}
                      selectableItemList={selectableItemList}
                      onItemUploadBtnClick={onItemUploadBtnClick}
                    />
                  </div>
                )}
              </div>
            </div>
          }
        />
        <div className={cx("main-area")}></div>
      </div>
    );
  }

  render() {
    return getDeviceType() === "mobile"
      ? this.mobileLayout()
      : this.desktopLayout();
  }
}

export default ItemAdderPanelView;
